import {
  IAnyComplexType,
  IAnyStateTreeNode,
  ModelPropertiesDeclaration,
} from 'mobx-state-tree';
import { ListModel, ExtendedModel } from 'mst-collection';

export function ExtendedListModel<
  T extends IAnyComplexType,
  TProps extends ModelPropertiesDeclaration,
  // TODO: fix types
  TOptions = any,
>(model: T, props: TProps, options: TOptions) {
  return ExtendedModel(
    ListModel(model, options as IAnyStateTreeNode),
    props,
  );
}
